/** Id de página de registro en el flujo escape room (backoffice + web). */
export const REGISTRATION_PAGE_ID = "registration";

export function isRegistrationPage(page) {
	if (!page) return false;
	if (String(page.pageId || page._id || "") === REGISTRATION_PAGE_ID) return true;
	if (page.registrationDesign) return true;
	return false;
}
